/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const stopwatch = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 3.8A5.6 5.6 0 1 1 8 15 5.6 5.6 0 0 1 8 3.8Zm0 0V1m3.733 4.2L12.9 4.033m-.233-.233.466.467M9.4 1H6.6M8 9.867 6.133 7.8"
    />
  </svg>
)
export default stopwatch
